import { render, staticRenderFns } from "./huodong.vue?vue&type=template&id=555ace5c"
import script from "./huodong.vue?vue&type=script&lang=js"
export * from "./huodong.vue?vue&type=script&lang=js"
import style0 from "./huodong.vue?vue&type=style&index=0&id=555ace5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports